import { Component, Input, OnInit } from '@angular/core';

import { ApplicationSettingsService } from 'src/app/services/application-settings.service';
import { ConversionService } from 'src/app/services/conversion.service';
import { RoutingProfileService } from 'src/app/services/vehicle-routing-profile.service';
import { SubscriptionManager } from 'src/app/_helpers/subscription-manager';
import { RoutingProfileModel } from 'src/app/_models/profilews/profilews';
import { CurrencyState } from 'src/app/_models/state/optionUIState';
import { RouteState } from 'src/app/_models/state/routeState';
import { getVehicleConfig } from '../../_helpers/vehicle-configuration';
import { VehicleConfigurationString } from '../../_models/vehicleConfigurationString';

@Component({
  selector: 'app-report-summary',
  templateUrl: './report-summary.component.html',
  styleUrls: ['./report-summary.component.scss'],
})
export class ReportSummaryComponent implements OnInit {
  profile: RoutingProfileModel;
  profileDetails: string;
  applicationData: any;
  vehicle: VehicleConfigurationString = {} as VehicleConfigurationString;
  constructor(
    private profileService: RoutingProfileService,
    private conversionService: ConversionService,
    private applicationSettingsService: ApplicationSettingsService
  ) {}
  @Input() route: RouteState;
  @Input() displayCurrency: CurrencyState;
  profileId: number;
  private sm = new SubscriptionManager();

  ngOnInit() {
    this.profile = this.profileService.getProfiles().find((p) => {
      return p.routingProfileId === this.route.profileId;
    });
    this.sm.manage = this.applicationSettingsService.store$.subscribe(
      (data) => {
        this.vehicle = getVehicleConfig(
          this.route,
          this.profile,
          this.conversionService
        );
        this.getRouteOptionsDetails(data);
      }
    );
  }

  getRouteOptionsDetails(data) {
    this.profileDetails = this.conversionService.getRoutingProfileSummary(
      this.profile,
      data,
      this.route
    );
  }
}
